// https://travishorn.com/adding-bootstrap-to-a-vue-cli-project-98c2a30e0ed0
import "bootstrap";

// https://stackoverflow.com/questions/34308004/moment-js-with-vuejs
import moment from "moment";

import axios from "axios";
import VueAxios from "vue-axios";
import VueAuth from "@websanova/vue-auth";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import VueFlashMessage from 'vue-flash-message';

// Application version from package.json
Vue.prototype.APPLICATION_VERSION = APPLICATION_VERSION;

// https://fontawesome.com/how-to-use/on-the-web/using-with/vuejs
// import { library } from '@fortawesome/fontawesome-svg-core'
// import { faCoffee } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// library.add(faCoffee)
// Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;

Vue.prototype.moment = moment;

Vue.router = router;

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL; //'http://lihavapp.test/api';

Vue.axios.defaults.headers.common = {
  // "Access-Control-Allow-Origin": "*",
  "Content-Type": "application/json",
  "Accept": "application/json",
};

Vue.use(VueAuth, {
  refreshData: { enabled: false, interval: 0},
  auth: require("@/auth/bearer.js"),
  http: require("@websanova/vue-auth/drivers/http/axios.1.x.js"),
  router: require("@websanova/vue-auth/drivers/router/vue-router.2.x.js"),
  rolesVar: "type",
  loginData: {
    redirect: 'profile'
  },
  parseUserData: function(data) {
    let user = {
      id: data.id || -1,
      username: data.username || ""
    }
    return user;
  }
});


require('vue-flash-message/dist/vue-flash-message.min.css');
Vue.use(VueFlashMessage, {
  messageOptions: {
    timeout: 6000,
  }
});

// https://github.com/websanova/vue-auth/blob/master/docs/StepByStepGuide.md
// Vue.http.interceptors.push(function(request, next) {
//   next(function (res) {

//       // Unauthorized Access
      
//       if (
//           res.status === 401 &&
//           ['UnauthorizedAccess', 'InvalidToken'].indexOf(res.data.code) > -1
//       ) {
//           Vue.auth.logout({
//               redirect: {name: 'auth-login'}
//           });
//       }
      
//       // System Error

//       else if (res.status === 500) {
//           Vue.router.push({name: 'error-500'});
//       }
//   });
// });


new Vue({
  router,
  render: h => h(App),
  watch: {
    '$route': function(to, from) {
      // store.clearAlerts();
  },
}
}).$mount("#app");

